import React from 'react';

// Material
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

// Components
import PromotionItem from './promotionItem';

const PromotionsTalbe = ({ title, currency, promotions, onDelete, onAdd, disabled }) => 
    <Paper variant='outlined' style={{ padding: 8 }}>
        <Grid container direction='column' spacing={1}>
            <Grid>
                <Typography component='span' variant='body1'>
                    <strong>{title}</strong>
                </Typography>
            </Grid>
            {
                !!promotions.length &&
                <>
                    <Grid container>
                        <Grid size={6}>
                            <Typography>Titulo</Typography>
                        </Grid>
                        <Grid size={(onDelete || onAdd) ? 4 : 6}>
                            <Typography align='right'>Descuento</Typography>
                        </Grid>
                        { (onDelete || onAdd) &&
                            <Grid size={2}>
                                <Typography align='right'>Acciones</Typography>
                            </Grid>}
                    </Grid>
                    { promotions.map((promotion, index) =>
                        <Grid key={index} container alignItems='center'>
                            <PromotionItem 
                                promotion={promotion}
                                onDelete={onDelete}
                                onAdd={onAdd}
                                currency={currency}
                                disabled={disabled}
                            />
                        </Grid>
                    )}
                </>
            }

            {
                !promotions.length &&
                <Grid>
                    <Typography component='span' variant='body1'>
                        No hay promociones aplicadas
                    </Typography>
                </Grid>
            }
        </Grid>
    </Paper>

export default PromotionsTalbe;